import Picture, { ImageOverlay } from './Picture';
import BaseGridScroll from './GridScroll';
import BaseTileWrapper from './Tile';
import { PlaceholderText } from './Placeholders';
import styled from 'styled-components';

const TileWrapper = styled(BaseTileWrapper)`
    display: flex;
    flex-direction: column;
    padding: 0px;
    border: 1px solid ${({ theme }) => theme.gray_5};
    border-radius: 6px;
    overflow: hidden;
    text-align: center;
    min-width: 100px;

    &:hover ${ImageOverlay}, &:focus-visible ${ImageOverlay} {
        background-image: linear-gradient(
            0deg,
            rgba(152, 100, 255, 0.15),
            rgba(152, 100, 255, 0.15)
        );
    }
`;

const PictureWrapper = styled.div`
    min-height: 100px;
    display: flex;
    transform: translateZ(0);
`;

function Tile({
    name,
    image,
    alt = '',
    isLoading,
    mixpanelContext = 'IndustryTile',
    ...props
}) {
    return (
        <TileWrapper $space="0" mixpanelContext={mixpanelContext} {...props}>
            <PictureWrapper isLoading={!!isLoading}>
                <Picture
                    src={image}
                    alt={alt}
                    isLoading={!!isLoading}
                    isDisabled={!!props.isDisabled}
                />
            </PictureWrapper>
            <span
                css={`
                    padding: ${({ theme }) => theme.space_4}px 0;
                `}
            >
                {name || (isLoading ? <PlaceholderText /> : '-')}
            </span>
        </TileWrapper>
    );
}

const GridScroll = styled(BaseGridScroll).attrs(
    ({ padding = `16px 18px 18px`, gap = `16px`, ...props }) => ({
        padding,
        gap,
        ...props,
    }),
)`
    & > li {
        flex: 1 1 120px;
    }

    @media screen and (min-width: ${({ theme }) => theme.bp.sm}px) {
        & > li {
            min-width: 120px;
            max-width: 313px;
        }
    }

    &:hover ${ImageOverlay}, &:focus-within ${ImageOverlay} {
        background-image: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0.15),
            rgba(255, 255, 255, 0.15)
        );
    }

    &:hover
        > :hover
        ${ImageOverlay},
        &:focus-within
        > :focus-within
        ${ImageOverlay} {
        background-image: linear-gradient(
            0deg,
            rgba(152, 100, 255, 0.15),
            rgba(152, 100, 255, 0.15)
        );
    }
`;

const IndustryTiles = { GridScroll, Tile };

export default IndustryTiles;
